import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IMvpExpertView } from '../models/mvp-experts.models';

@Injectable({
  providedIn: 'root',
})
export class MvpExpertsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = '/experts/mvp';

  getMvpExperts(opportunityId: string): Observable<IMvpExpertView[]> {
    return this.http.get<IMvpExpertView[]>(
      `${this.baseUrl}/opportunity/${opportunityId}`
    );
  }
}
